<template>
  <div>
    <!-- <h1>This is view Package Package {{ packname }}</h1> -->
    <b-card
      header="Package"
      header-tag="header"
      :title="packname"
      header-text-variant="white"
      :border-variant="getColour()"
      :header-bg-variant="getColour()"
      align="left"
      class="mt-3"
      :footer-html="getFooter()"
    >
      <b-card-text>Package details as follows</b-card-text>
      <b-list-group flush>
        <b-list-group-item
          ><strong>Max Admins: </strong>{{ maxadmins }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Max Users: </strong>{{ maxusers }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Max ADIs: </strong>{{ maxadis }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Contract Length: </strong
          >{{ contractlength | monthf }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Initial Payment: </strong
          >{{ initpay | money }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Reguter Payment: </strong
          >{{ regpay | money }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Payment Frequency: </strong
          >{{ payfreq | payfrqname }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Discount Code: </strong>{{ promocode }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>T & C Reference: </strong>{{ tcref }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Added On: </strong>
          {{ addedon | justdate }}</b-list-group-item
        >
      </b-list-group>
      <!-- <b-card-footer>
        <a v-if="state == 1" href="#" class="card-link">Manage Package</a>
        <strong v-else>Ended On: {{ endday }}</strong>
      </b-card-footer> -->
    </b-card>
  </div>
</template>

<script>
export default {
  name: "PackageCard",
  props: {
    packname: String,
    state: Number,
    endday: String,

    maxadmins: Number,
    maxusers: Number,
    maxadis: Number,
    contractlength: Number,
    initpay: Number,
    regpay: Number,
    payfreq: Number,
    promocode: String,
    tcref: String,
    addedon: String
  },
  data() {
    return {
      EndDay: this.endday
    };
  },

  methods: {
    getColour() {
      return parseInt(this.state) == 1 ? "info" : "danger";
    },
    getFooter() {
      return parseInt(this.state) == 1
        ? "<a href='deletePackage()' class=' nolink' >Manage Package</a>"
        : "<strong>Discontinued On: " + this.EndDay + "</strong>";
    } /*,card-link
    deletePackage() {
      this.$confirm({
        title: "Delete Package",
        text: "Are you sure you want to DELETE this package?",
        type: "warning"
        //timer: 6000
      }).then(r => {
        console.log(r.value);
      });
    }*/
  }
};
</script>
<style>
.nolink {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
</style>
